import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, FormText} from 'reactstrap';
import {ChannelLogo} from "../../channels/ChannelLogo";
import {GoogleLinkComponent} from "../link_acocunts/GoogleLinkt";
import {FacebookLinkComponent} from "../link_acocunts/FacebookLink";
import {TikTokLinkComponent} from "../link_acocunts/TiktokLink";
import {LinkedinLinkComponent} from "../link_acocunts/LinkedinLink";
import {GA4LinkComponent} from "../link_acocunts/GA4Link";
import {GSCLinkComponent} from "../link_acocunts/GSCLink";
import {DV360LinkComponent} from "../link_acocunts/DV360Link";
import {EscalafyConnectButton} from "./EscalafyConnectButton";
import {forgetReconnect} from "./reconnectNote";
import {MercadoAdsChooseStep} from "../../channels/mercado_ads/MercadoAdsChooseStep";
import {SendConnectionLinkModal} from "../../connection_links/SendConnectionLinkModal";
import {
    GOOGLE_CHANNEL, FACEBOOK_CHANNEL, TIKTOK_CHANNEL, LINKEDIN_CHANNEL, ANALYTICS_CHANNEL,
    SEARCH_CONSOLE_CHANNEL, DV360_CHANNEL, ESCALAFY_CHANNEL, MERCADO_ADS_CHANNEL
} from "../../channels/channels";
import {channelName} from "../../line_wizard/accountsList";
import { withTranslation } from 'react-i18next';


const CHANNEL_DISPLAY_NAMES = {
    [GOOGLE_CHANNEL]: 'Google Ads',
    [FACEBOOK_CHANNEL]: 'Meta Ads',
    [TIKTOK_CHANNEL]: 'TikTok Ads',
    [LINKEDIN_CHANNEL]: 'LinkedIn Ads',
    [ANALYTICS_CHANNEL]: 'GA4',
    [SEARCH_CONSOLE_CHANNEL]: 'Google Search Console',
    [DV360_CHANNEL]: 'Display & Video 360',
    [ESCALAFY_CHANNEL]: 'Escalafy',
};

class AddCredentialModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            name: '',
            sendLinkOpen: false,
        };
        this.toggle = this.toggle.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleBeforeConnect = this.handleBeforeConnect.bind(this);
        this.openSendLink = this.openSendLink.bind(this);
    }

    // «Enviar link al vendedor» (Mercado Ads): se cierra este modal y se abre el del link, que pide el
    // cliente si no vino uno.
    openSendLink() {
        this.setState({modal: false, sendLinkOpen: true});
    }

    toggle() {
        this.setState(prev => ({
            modal: !prev.modal,
            name: prev.modal ? '' : prev.name,
        }));
    }

    handleNameChange(e) {
        this.setState({name: e.target.value});
    }

    handleBeforeConnect() {
        // Una conexión nueva no hereda el «Reconectar» de una cuenta que se abandonó (`reconnectNote`).
        forgetReconnect();
        // LinkedIn y Escalafy llevan el nombre en su nota de sessionStorage (prop), no acá.
        if (this.props.channel === LINKEDIN_CHANNEL || this.props.channel === ESCALAFY_CHANNEL) return;
        if (this.state.name.trim()) {
            localStorage.setItem('pending_credential_label', this.state.name.trim());
        }
    }

    renderLinkComponent() {
        const {channel} = this.props;
        const noop = () => {};
        switch (channel) {
            case GOOGLE_CHANNEL:
                return <GoogleLinkComponent hasConnection={false} onConnectionDeleted={noop}/>;
            case FACEBOOK_CHANNEL:
                return <FacebookLinkComponent hasConnection={false} onConnectionDeleted={noop}/>;
            case TIKTOK_CHANNEL:
                return <TikTokLinkComponent hasConnection={false} onConnectionDeleted={noop}/>;
            case LINKEDIN_CHANNEL:
                return <LinkedinLinkComponent hasConnection={false} onConnectionDeleted={noop}
                                              credentialLabel={this.state.name.trim()}/>;
            case ANALYTICS_CHANNEL:
                return <GA4LinkComponent hasConnection={false} onConnectionDeleted={noop}/>;
            case SEARCH_CONSOLE_CHANNEL:
                return <GSCLinkComponent hasConnection={false} onConnectionDeleted={noop}/>;
            case DV360_CHANNEL:
                return <DV360LinkComponent hasConnection={false} onConnectionDeleted={noop}/>;
            case ESCALAFY_CHANNEL:
                return <EscalafyConnectButton label={this.state.name.trim()}/>;
            default:
                return null;
        }
    }

    // Mercado Ads no pide nombre: la conexión se llama como el vendedor que autoriza (el backend la
    // reconoce por su usuario de Mercado Libre). Antes de ir, el paso «¿Quién va a dar el acceso?».
    renderMercadoAds(displayName) {
        const {channel, t, agencyClientId} = this.props;
        return (
            <>
                <Modal isOpen={this.state.modal} toggle={this.toggle} backdrop="static" className="ma-add-modal">
                    <ModalHeader toggle={this.toggle}>
                        <ChannelLogo channel={channel}/>&nbsp;{t('add_credential_modal.title', {channel: displayName})}
                    </ModalHeader>
                    <ModalBody>
                        <MercadoAdsChooseStep onSendLink={this.openSendLink} agencyClientId={agencyClientId || null}/>
                    </ModalBody>
                </Modal>
                <SendConnectionLinkModal show={this.state.sendLinkOpen}
                                         onHide={() => this.setState({sendLinkOpen: false})}
                                         channel={MERCADO_ADS_CHANNEL}
                                         agencyClientId={agencyClientId || undefined}/>
            </>
        );
    }

    render() {
        const {channel, t} = this.props;
        const {name} = this.state;
        // Un canal sin nombre en la tabla cae al de `channels.js` y, si tampoco está, al código.
        const displayName = CHANNEL_DISPLAY_NAMES[channel] || channelName(channel);
        const isNameValid = name.trim().length > 0;

        if (channel === MERCADO_ADS_CHANNEL) return this.renderMercadoAds(displayName);

        return (
            <Modal isOpen={this.state.modal} toggle={this.toggle} backdrop="static">
                <ModalHeader toggle={this.toggle}>
                    <ChannelLogo channel={channel}/>&nbsp;{t('add_credential_modal.title', {channel: displayName})}
                </ModalHeader>
                <ModalBody style={{padding: '1.5em'}}>
                    <FormGroup>
                        <Label>{t('add_credential_modal.name_label')}</Label>
                        <Input
                            type="text"
                            value={name}
                            onChange={this.handleNameChange}
                            placeholder={t('add_credential_modal.name_placeholder')}
                        />
                        <FormText>{t('add_credential_modal.name_hint')}</FormText>
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <div
                        onClickCapture={this.handleBeforeConnect}
                        style={{
                            pointerEvents: isNameValid ? 'auto' : 'none',
                            opacity: isNameValid ? 1 : 0.5,
                        }}
                    >
                        {this.renderLinkComponent()}
                    </div>
                </ModalFooter>
            </Modal>
        );
    }
}

export const AddCredentialModal = withTranslation()(AddCredentialModalClass);
export default AddCredentialModal;
